import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AdminProvider } from './context/AdminContext';
import HomePage from './pages/HomePage';
import BroadcastPage from './pages/BroadcastPage';
import MediaPage from './pages/MediaPage';
import AdsPage from './pages/AdsPage';
import Login from "./pages/Login";
import AdminAppBar from "./pages/AdminAppBar";
import {Box} from "@mui/material";
import Footer from "./pages/Footer";
import { motion } from 'framer-motion';

const App = () => {
    // Initialize authentication state from localStorage to persist on refresh
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(() => {
        return localStorage.getItem('isAdmin') === 'true';
    });
    const handleLogout = () => {
        localStorage.removeItem('isAdmin');
        setIsAuthenticated(false);
        window.location.href = '/'; // Simple redirect to login
    };

    // Helper component to guard private routes
    const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
        return isAuthenticated ? <>{children}</> : <Navigate to="/" replace />;
    };

    return (
        <AdminProvider>
            <motion.div
                style={{
                    position: 'fixed',
                    top: 0, left: 0, width: '100vw', height: '100vh',
                    zIndex: -1,
                    background: 'linear-gradient(45deg, #4158D0, #C850C0, #FFCC70)',
                }}
                animate={{
                    background: [
                        'linear-gradient(45deg, #4158D0, #C850C0, #FFCC70)',
                        'linear-gradient(45deg, #FFCC70, #4158D0, #C850C0)',
                        'linear-gradient(45deg, #C850C0, #FFCC70, #4158D0)',
                    ]
                }}
                transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
            />

         <BrowserRouter>
             <Box sx={{ display: 'flex',
                 flexDirection: 'column',
                 minHeight: '100vh',
                 alignItems: 'center', // Centers horizontal
                 width: '100%'}}>
             {isAuthenticated && <AdminAppBar handleLogout={handleLogout} />}
                 <Box sx={{
                     flex: 1,
                     width: '100%',
                     maxWidth: '1200px',
                     display: 'flex',
                     flexDirection: 'column',
                     alignItems: 'center',
                     py: 4
                 }}>


         <Routes>
                    {/* Public Login Route */}
                    <Route
                        path="/"
                        element={<Login setAuth={setIsAuthenticated} />}
                    />

                    {/* Protected Routes */}
                    <Route
                        path="/Home"
                        element={
                            <ProtectedRoute>
                                <HomePage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/broadcast"
                        element={
                            <ProtectedRoute>
                                <BroadcastPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/media"
                        element={
                            <ProtectedRoute>
                                <MediaPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/ads"
                        element={
                            <ProtectedRoute>
                                <AdsPage />
                            </ProtectedRoute>
                        }
                    />
                </Routes></Box></Box>
             {isAuthenticated && <Footer />}
            </BrowserRouter>
        </AdminProvider>
    );
};

export default App;